module.exports = __webpack_public_path__ + "static/media/Terras.09031c71.mp3";